// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table {
  margin: 1em;
  display: flex;
  flex-direction: column;
}
.table .header, .table .row {
  display: flex;
}
.table .header div, .table .row div {
  flex: 1 1;
  padding: 0.2rem 0.4em;
  border: 1px solid rgb(238, 238, 238);
}
.table .header {
  background-color: rgb(238, 238, 238);
}
.table .header div {
  cursor: pointer;
}

.list-row .avatar-D {
  background: #f34225;
}

.list-row .avatar-SP {
  background: #357dff;
}

.list-row .avatar-R {
  background: rgba(71, 17, 38, 0.9921568627);
}

.list-row .avatar-A {
  background: #59c785;
}

.list-row .avatar-AA {
  background: #ee8a32;
}

.list-row .avatar-U {
  background: #f3f3f3;
  color: #666;
}`, "",{"version":3,"sources":["webpack://./src/Components/Users/usersModal.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;AACJ;AACI;EACE,aAAA;AACN;AACM;EACE,SAAA;EACA,qBAAA;EACA,oCAAA;AACR;AAGI;EACE,oCAAA;AADN;AAEM;EACE,eAAA;AAAR;;AAIE;EACE,mBAAA;AADJ;;AAGE;EACE,mBAAA;AAAJ;;AAEE;EACE,0CAAA;AACJ;;AACE;EACE,mBAAA;AAEJ;;AAAE;EACE,mBAAA;AAGJ;;AADE;EACE,mBAAA;EACA,WAAA;AAIJ","sourcesContent":[".table {\n    margin: 1em;\n    display: flex;\n    flex-direction: column;\n    \n    .header, .row {\n      display: flex;\n      \n      div {\n        flex: 1;\n        padding: 0.2rem 0.4em;\n        border: 1px solid rgb(238, 238, 238);\n      }\n    }\n    \n    .header {\n      background-color: rgb(238, 238, 238);\n      div { \n        cursor: pointer;\n      }\n    }\n  }\n  .list-row .avatar-D{\n    background: #f34225\n  }\n  .list-row .avatar-SP{\n    background: #357dff\n  }\n  .list-row .avatar-R{\n    background: #471126fd\n  }\n  .list-row .avatar-A{\n    background: #59c785\n  }\n  .list-row .avatar-AA{\n    background: #ee8a32;\n  }\n  .list-row .avatar-U{\n    background: #f3f3f3;\n    color: #666\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
